<template>
<div>
    <HeaderContent header="ตั้งค่าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentSetting />
    <ContentDeliveryRateList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentSetting from '@/components/menuadmin/content/contentsetting/MenuContentSetting.vue'
import ContentDeliveryRateList from '@/components/menuadmin/content/contentsetting/ContentDeliveryRateList.vue'

export default {
    name: 'contentDeliveryRate',
    components: {
        HeaderContent,
        MenuContentSetting,
        ContentDeliveryRateList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
